<template>
  <v-card variant="outlined" rounded class="my-1">
    <v-card-text class="pa-2">
      <p class="my-0">Tipologia sedute <code>seats_types</code>: <span :class="`${isChanged ? ' font-weight-bold':''}`">{{modelValue.seats_types.map(sTypeName).join(', ')}}</span></p>
      <p class="my-0">N° sedute <code>num_seats</code>: <span :class="`${isChanged ? ' font-weight-bold':''}`">{{modelValue.num_seats}}</span></p>
      <p class="my-0">Durata in giorni <code>duration</code>: <span :class="`${isChanged ? ' font-weight-bold':''}`">{{modelValue.duration}}</span></p>
      <p class="my-0">Consumabile <code>consumable</code>: <span :class="`${isChanged ? ' font-weight-bold':''}`">{{modelValue.consumable ? 'Sì' : 'No'}}</span></p>
      <p class="my-0">Pacchetto principale <code>main</code>: <span :class="`${isChanged ? ' font-weight-bold':''}`">{{modelValue.main ? 'Sì' : 'No'}}</span></p>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {defineComponent, type PropType} from 'vue'
import {type ProductSeats, SeatsType} from "@/models.ts";

export default defineComponent({
  name: "ProductSeatsCard",
  props : {
    modelValue : {
      type : Object as PropType<ProductSeats>,
      required : true
    },
    isChanged : Boolean,
  },
  setup(props, ctx) {
    return {
      sTypeName(s:SeatsType):string {
        switch (s) {
          case SeatsType.exp:
            return "TopGym experience";
          case SeatsType.corsi:
            return "Sala corsi";
          case SeatsType.opengym:
            return "Open gym";
          case SeatsType.vacu:
            return "Vacu";
        }
        return s
      },
    }
  }
})
</script>

<style scoped>

</style>